import React, {useState} from "react";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton,
} from '@mui/x-data-grid';
import {Typography} from '@material-ui/core';
import {useSelector} from "react-redux";
import {map_events} from "./utils/mapping";
import {formattingMoney, formattingPercent} from "./utils/formatting";
import {getCurrencySymbol} from "./utils/currency";


export default function () {
    const data = useSelector(store => store.portfolio?.data);
    const rows = map_events(data.events.dividends, data.s.securities);
    const [sortModel, setSortModel] = useState([
        {
            field: 'd',
            sort: 'desc',
        },
    ]);
    const columns = [
        {
            field: 'ticker',
            headerName: 'Актив',
            description: 'Актив',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{params.value}</Typography>
                    <Typography color="textSecondary" variant="body2">{params.api.getCellValue(params.id, 'name')}</Typography>
                </div>
            )
        },
        {
            field: 'd',
            type: 'date',
            align: 'right',
            headerName: 'Дата',
            description: 'Дата',
            valueFormatter: (params) => {
                return `${(new Date(params.value)).toLocaleDateString('ru-RU',{year: 'numeric', month: 'short', day: 'numeric'})}`;
            },
            width: 125,
        },
        {
            field: 'v_pc',
            headerName: 'Размер',
            description: 'Размер',
            type: 'number',
            align: 'right',
            minWidth: 70,
            // valueFormatter: (params) => {
            //     return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}`;
            // },
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 'v')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 's_pc',
            headerName: 'Сумма',
            description: 'Сумма',
            type: 'number',
            align: 'right',
            minWidth: 70,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 's')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 'cnt',
            headerName: 'Кол-во',
            description: 'Количество бумаг, по которым был выплачен дивиденд',
            type: 'number',
            align: 'right',
            minWidth: 90,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))}`;
            },
        },
        {
            field: 'nalog_pc',
            headerName: 'Налог',
            description: 'Налог',
            type: 'number',
            align: 'right',
            width: 120,
            // valueFormatter: (params) => {
            //     return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}`;
            // },
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingPercent(Number(params.api.getCellValue(params.id, 'nalog_perc')))} % {formattingMoney(Number(params.api.getCellValue(params.id, 'nalog')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 's_n_pc',
            headerName: 'Начислено',
            description: 'Сумма дивиденда после вычета налога',
            type: 'number',
            align: 'right',
            minWidth: 70,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{formattingMoney(Number(params.value))} {getCurrencySymbol(data.portfolio.currency)}</Typography>
                    <Typography color="textSecondary" variant="body2">{formattingMoney(Number(params.api.getCellValue(params.id, 's_n')))} {getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}</Typography>
                </div>
            )
        },
        {
            field: 'sec_price',
            headerName: 'Цена отсечки бумаги',
            description: 'Цена отсечки бумаги',
            type: 'number',
            align: 'right',
            width: 120,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(params.api.getCellValue(params.id, 'cur'))}`;
            },
        },
        {
            field: 'yield_sec_price',
            headerName: 'Доходность к цене отсечки',
            description: 'Доходность к цене отсечки',
            type: 'number',
            align: 'right',
            width: 120,
            valueFormatter: (params) => {
                return `${formattingPercent(Number(params.value))} %`;
            },
        },
        {
            field: 'average_price_pc',
            headerName: 'Cредняя цена покупки бумаги в валюте портфеля',
            description: 'Cредняя цена покупки бумаги в валюте портфеля',
            type: 'number',
            align: 'right',
            width: 120,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))} ${getCurrencySymbol(data.portfolio.currency)}`;
            },
        },
        {
            field: 'yield_average_price',
            headerName: 'Доходность относительно средней цены покупки бумаги',
            description: 'Доходность относительно средней цены покупки бумаги',
            type: 'number',
            align: 'right',
            width: 120,
            valueFormatter: (params) => {
                return `${formattingPercent(Number(params.value))} %`;
            },
        },
    ];

    return (
                <DataGrid
                    autoHeight
                    pageSize={25}
                    columns={columns}
                    rows={rows}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                    disableColumnMenu
                    components={{
                        Toolbar: function CustomToolbar() {
                            return (
                                <GridToolbarContainer>
                                    <GridToolbarColumnsButton />
                                    <GridToolbarFilterButton />
                                </GridToolbarContainer>
                            );
                        },
                    }}
                />
    );
}
